import React from 'react'
import PropTypes from 'prop-types'
import { generatePath, Link } from 'react-router-dom'
import JobStatusLabel from './JobStatusLabel'
import CursorPagination from './cursor-pagination'
import { prettyAddressWithDetails } from '../utilities/locationUtilities'
import { formatDate } from '../utilities/formatters'
import { ROUTES } from '../routes'
import { useSelector } from 'react-redux'
export default function ClientJobsTable ({ jobs, title, onPageRequest, client, fakeCount, openJobsCount }) {
  const { hauler } = useSelector(({ user }) => ({ hauler: user.hauler }))

  const newJobParams = new URLSearchParams()
  if (client?.id) newJobParams.append('client_id', client.id)

  const openJobsParams = new URLSearchParams({ status: 'open' })
  if (client?.id) openJobsParams.append('clientId', client.id)

  const closedJobsParams = new URLSearchParams({ status: 'closed' })
  if (client?.id) closedJobsParams.append('clientId', client.id)
  return (
    <div className='row panel panel-default'>
      <div className='panel-heading'>
        <div className='container-fluid'>
          {title === 'Open Jobs' && (
            <div>
              <h4 className='pull-left'>
                {title}
                {` - ${openJobsCount ?? 0} jobs`}
                &nbsp;
                <Link to={`${ROUTES.jobs}?${openJobsParams.toString()}`}>
                  <small className='text-primary link'>(View All Open Jobs)</small>
                </Link>
              </h4>
              <Link
                to={`${ROUTES.newJob}?${newJobParams.toString()}`}
                className='btn btn-lg btn-primary pull-right'>
                <span className='pull-left hidden-xs'>Create New Job</span>
                <i className='material-icons pull-right thumbster-button-icon no-margin-bs-xs'>add_circle</i>
              </Link>
            </div>
          )}
          {title === 'Closed Jobs' && (
            <div>
              <h4 className='pull-left'>
                {title}
                {` - ${client?.closedJobsCount ?? 0} jobs`}
                &nbsp;
                <Link to={`${ROUTES.jobs}?${closedJobsParams.toString()}`}>
                  <small className='text-primary link'>(View All Closed Jobs)</small>
                </Link>
              </h4>
            </div>
          )}
        </div>
      </div>
      <div className='panel-body table-responsive'>
        <table className='table table-striped'>
          <thead>
            <tr>
              <th>ID</th>
              <th>Status</th>
              <th>Address</th>
              <th>Recurring Tickets</th>
              <th>On Demand Tickets</th>
              <th>Open Tickets</th>
              <th>Closed Tickets</th>
              <th>Last Serviced</th>
              <th>View Details</th>
            </tr>
          </thead>
          <tbody>
            {jobs.nodes.length === 0
              ? (
                <tr>
                  <td colSpan={9}>
                    <h4 className='text-center'>No Jobs</h4>
                  </td>
                </tr>
                )
              : jobs.nodes.map(job => {
                const jobPath = generatePath(ROUTES.job, { id: job.id })
                const jobParams = new URLSearchParams({})

                const activeTicketParams = new URLSearchParams({ jobCustomId: job.customId, status: 'active' })
                const terminalTicketParams = new URLSearchParams({ jobCustomId: job.customId, status: 'terminal' })
                const recurringTicketsParams = new URLSearchParams({ jobCustomId: job.customId, serviceFrequency: 'RECURRING' })
                const onDemandTicketsParams = new URLSearchParams({ jobCustomId: job.customId, serviceFrequency: 'ON_DEMAND' })

                return (
                  <tr key={job.id}>
                    <td>
                      <Link to={`${jobPath}${hauler.isRecurringServiceEnabled ? `?${jobParams.toString()}` : ''}`}>
                        {job.customId}
                      </Link>
                    </td>
                    <td>
                      <div>
                        <Link to={jobPath}>
                          <JobStatusLabel status={job.status} />
                        </Link>
                      </div>
                    </td>
                    <td>
                      <div>{prettyAddressWithDetails(job)}</div>
                    </td>
                    <td>
                      {job.recurringTicketsCount === 0
                        ? 'None'
                        : (
                          <Link to={`${ROUTES.ticketSearch}?${recurringTicketsParams.toString()}`}>
                            {job.recurringTicketsCount}
                          </Link>
                          )
                      }
                    </td>
                    <td>
                      {job.onDemandTicketsCount === 0
                        ? 'None'
                        : (
                          <Link to={`${ROUTES.ticketSearch}?${onDemandTicketsParams.toString()}`}>
                            {job.onDemandTicketsCount}
                          </Link>
                          )
                      }
                    </td>
                    <td>
                      {job.activeTicketsCount === 0
                        ? 'None'
                        : (
                          <Link to={`${ROUTES.ticketSearch}?${activeTicketParams.toString()}`}>
                            {job.activeTicketsCount}
                          </Link>
                          )
                      }
                    </td>
                    <td>
                      {job.terminalTicketsCount === 0
                        ? 'None'
                        : (
                          <Link to={`${ROUTES.ticketSearch}?${terminalTicketParams.toString()}`}>
                            {job.terminalTicketsCount}
                          </Link>
                          )
                      }
                    </td>
                    <td>
                      {formatDate(job.lastServicedAt)}
                    </td>
                    <td>
                      <Link to={`${jobPath}${hauler.isRecurringServiceEnabled ? `?${jobParams.toString()}` : ''}`}>
                        <i className='material-icons medium-icon'>info</i>
                      </Link>
                    </td>
                  </tr>
                )
              })
          }
          </tbody>
        </table>
        {jobs.totalCount > 0 && <CursorPagination
          pageInfo={jobs.pageInfo}
          totalCount={jobs.totalCount}
          onPageRequest={onPageRequest}
          fakeCount={fakeCount}
                                />}
      </div>
    </div>
  )
}

ClientJobsTable.propTypes = {
  client: PropTypes.shape({
    id: PropTypes.string.isRequired,
    closedJobsCount: PropTypes.number.isRequired
  }).isRequired,
  jobs: PropTypes.shape({
    nodes: PropTypes.arrayOf(PropTypes.object).isRequired,
    pageInfo: PropTypes.shape({
      endCursor: PropTypes.string,
      hasNextPage: PropTypes.bool.isRequired,
      hasPreviousPage: PropTypes.bool.isRequired,
      startCursor: PropTypes.string
    }).isRequired,
    totalCount: PropTypes.number.isRequired
  }).isRequired,
  onPageRequest: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  fakeCount: PropTypes.shape({
    start: PropTypes.number.isRequired,
    end: PropTypes.number.isRequired
  }),
  openJobsCount: PropTypes.number
}
